import { render, staticRenderFns } from "./GoodDamageCategoriesForm.vue?vue&type=template&id=18f8da44&scoped=true"
import script from "./GoodDamageCategoriesForm.vue?vue&type=script&lang=ts"
export * from "./GoodDamageCategoriesForm.vue?vue&type=script&lang=ts"
import style0 from "./GoodDamageCategoriesForm.vue?vue&type=style&index=0&id=18f8da44&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18f8da44",
  null
  
)

export default component.exports